import React, { FormEvent } from 'react';
import { Search, UserRound, X } from 'lucide-react';

export type CrmCustomerOption = {
  id?: string | number;
  name?: string;
  nome?: string;
  phone?: string;
  telefone?: string;
  email?: string;
  origin?: string;
};

export type ReservationFormCrmSearchModalProps = {
  open: boolean;
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
  results: CrmCustomerOption[];
  loading: boolean;
  error: string;
  onClose: () => void;
  onSearch: (event?: FormEvent) => void;
  onSelect: (customer: CrmCustomerOption) => void;
};

export default function ReservationFormCrmSearchModal({
  open,
  searchTerm,
  onSearchTermChange,
  results,
  loading,
  error,
  onClose,
  onSearch,
  onSelect,
}: ReservationFormCrmSearchModalProps) {
  if (!open) return null;

  return (
    <div className="delete-confirm-overlay" role="presentation" onMouseDown={onClose}>
      <div
        className="delete-confirm-modal crm-client-search-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="crm-client-search-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="crm-client-search-header">
          <span className="crm-client-search-icon"><UserRound size={21} /></span>
          <div>
            <h4 id="crm-client-search-title">Buscar cliente no CRM</h4>
            <p>Pesquise por nome ou telefone e selecione o cliente da reserva.</p>
          </div>
          <button
            type="button"
            className="crm-client-search-close"
            onClick={onClose}
            disabled={loading}
            aria-label="Fechar busca de clientes"
          >
            <X size={18} />
          </button>
        </div>

        <form className="crm-client-search-form" onSubmit={onSearch}>
          <div className="crm-client-search-input-wrap">
            <Search size={17} aria-hidden="true" />
            <input
              autoFocus
              type="search"
              value={searchTerm}
              onChange={(event) => onSearchTermChange(event.target.value)}
              placeholder="Nome ou telefone do cliente"
              maxLength={100}
              aria-label="Nome ou telefone para buscar no CRM"
            />
          </div>
          <button type="submit" disabled={loading || searchTerm.trim().length < 2}>
            {loading ? 'Buscando...' : 'Buscar'}
          </button>
        </form>

        {error && <p className="crm-client-search-message" role="alert">{error}</p>}

        {results.length > 0 && (
          <div className="crm-client-search-results" role="list" aria-label="Clientes encontrados">
            {results.map((customer, index) => {
              const customerName = customer.name || customer.nome || 'Cliente sem nome';
              const customerPhone = customer.telefone || customer.phone || 'Telefone não informado';
              return (
                <button
                  key={`${customer.id || customerPhone}-${index}`}
                  type="button"
                  role="listitem"
                  className="crm-client-search-result"
                  onClick={() => onSelect(customer)}
                >
                  <span className="crm-client-search-avatar" aria-hidden="true">
                    {customerName.trim().charAt(0).toUpperCase() || '?'}
                  </span>
                  <span className="crm-client-search-result-copy">
                    <strong>{customerName}</strong>
                    <span>{customerPhone}{customer.email ? ` · ${customer.email}` : ''}</span>
                  </span>
                  {customer.origin && <span className="crm-client-search-origin">{customer.origin}</span>}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
